module.exports = __webpack_public_path__ + "img/troyers-cropped.06b07c2a.png";